var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useCallback } from 'react';
import { useApiPut } from '@sierralabs/core-ui';
export function useMoveFile() {
    const _a = useApiPut('files/move'), { put } = _a, result = __rest(_a, ["put"]);
    const moveFile = useCallback((dto) => put(dto), [put]);
    return Object.assign(Object.assign({}, result), { moveFile });
}
//# sourceMappingURL=useMoveFile.js.map